var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"custom-deck-builder\">\n	<div class=\"page-title\">\n		<h1>\n			<span class=\"title\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "</span>\n			<span class=\"subtitle\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"subtitle") : depth0), depth0))
    + "</span>\n		</h1>\n	</div>\n	<main></main>\n	<footer>Cryptozoic engine &copy; "
    + alias2(__default(require("../../handlebars-helpers/currentYear.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"currentYear","hash":{},"data":data,"loc":{"start":{"line":9,"column":34},"end":{"line":9,"column":49}}}))
    + " <a href=\"https://www.cryptozoic.com/\">Cryptozoic Entertainment</a>. This is a fan project by <a href=\"https://github.com/JacobFischer\">Jacob Fischer</a>. Source availible on <a href=\"https://github.com/JacobFischer/Custom-Deck-Builder\">Github</a>.</footer>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/gui/ui/ui.hbs
// module id = 255
// module chunks = 0